<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" :max-width="800" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 View stock
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close
    v-divider
    v-card-text.px-6.py-3
      div.d-flex.mt-3
        div
          .text-lg.font-semibold.neutral700--text {{ product.name }}
          .text-sm.font-semibold.neutral500--text(v-if="product.uom") UOM: {{ product.uom }}
        v-spacer
        .text-md.font-semibold.neutral700--text Changes ({{ stock.change }})
      //- Document info
      .text-lg.font-semibold.neutral700--text.mt-6 {{ documentType === 'Invoice' ? 'Invoice' : 'Purchase order' }}
      .text-sm {{ documentNumber }}
      v-row.mt-6
        //- Stock cost
        v-col(cols="6")
          .text-lg.font-semibold.neutral700--text Stock cost
          .text-sm {{ stockCost }}
        //- Cost per item
        v-col(cols="6")
          .text-lg.font-semibold.neutral700--text Cost per item
          .text-sm {{ costPerItem | displayPrice }}
      v-row.mt-6
        //- Batch no
        v-col(cols="6")
          .text-lg.font-semibold.neutral700--text Batch no
          .text-sm {{ stock.batch_no }}
        //- Cost per item
        v-col(cols="6")
          .text-lg.font-semibold.neutral700--text Expiry date
          .text-sm(v-if="stock.expiry_date") {{ stock.expiry_date | humanizeDate }}

    v-card-actions.pb-4.pt-3.px-6
      v-spacer
      y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="md" button-class="px-0" @click="closeDialog")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MedicationSoldByDropdown from '@/components/clinic/inventory/MedicationSoldByDropdown.vue'
import InvoiceDropdown from '@/components/clinic/inventory/InvoiceDropdown.vue'
import { displayPrice } from "@/plugins/filters";

export default {
  components: { MedicationSoldByDropdown, InvoiceDropdown },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    stock: {
      default: null
    },
    product: {
      default: null
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    documentType () {
      return this.stock.purchase_item.order ? 'purchaseOrder' : 'Invoice'
    },
    documentNumber () {
      const name = this.documentType === 'purchaseOrder' ? 'PO' : 'INV'
      return `${name} #${this.stock.invoice.rid}`
    },
    costPerItem () {
      const stock = this.stock.change || 0
      const cost = this.stock.purchase_item.cost || 0
      return Number(cost) / (Number(stock) || 1)
    },
    stockCost () {
      if (!this.stock.purchase_item?.cost) return null

      return displayPrice(this.stock.purchase_item.cost)
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    closeDialog () {
      this.$emit('closed')
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .date-field .v-input__append-inner {
    margin-top: 12px !important;
  }
}
</style>